export const brandConfig = {
  name: 'South Eastern Bakery',
  descriptor: 'Global Flatbreads',
  logoSrc: 'https://media-manager-c.questera.ai/greta-media/4948ae8bd3a71eaecd010e3b75a418c9afeda68ebd57283642e35d04cbb3fca3a3104393b4fae87688db585a45c44e03/images/aW1hZ2UvcG5n/54445740970cfa0160eec03d20ce8593.png',
  contactEmail: '[INDSÆT OFFICIEL KONTAKTMAIL]'
};

export const hasOfficialContactEmail = () => {
  return Boolean(
    brandConfig.contactEmail &&
    !brandConfig.contactEmail.includes('[INDSÆT')
  );
};